import React, { useState } from "react";
import './MemecoinGenerator.css'
const phrases = [
  "fade the next 100x",
  "paperhand at the top",
  "ape into a rug",
  "buy the dip, watch it dip more",
  "send it to Valhalla",
  "diamond hands through the bear market",
  "watch a memecoin do a 1000x and still not buy",
  "sell right before the pump",
  "get rugged and still buy more",
  "hodl until zero",
  "get liquidated on 50x leverage",
  "believe in the meme more than the fundamentals",
  "trust the process while the devs cash out",
  "shill your bags to the timeline",
  "buy top, sell bottom, repeat",
  "wait for the dip that never comes",
  "watch influencers dump after hyping it up",
  "go all-in on a dog coin",
  "fall for the 'it's different this time'",
  "max bid on a dead chain",
  "listen to CT calls and regret it later",
  "watch a friend get rich while you fade",
  "sell for a 2x when it does a 500x",
  "stake and pray",
  "ignore fundamentals because it's a meme coin",
  "think this one is actually a serious project",
  "wait for utility on a memecoin",
  "convince yourself 'it's still early'",
  "go into a space full of influencers who dumped already",
  "tell yourself 'it's only a paper loss'",
  "buy high sell low like a pro",
  "fomo into a coin after seeing one rocket emoji",
  "mistake a honeypot for the next bitcoin",
  "join a pump group and get dumped on",
  "market buy with 100% slippage",
  "spend more on gas than the actual token",
  "ape your life savings into something called ElonCumRocket",
  "believe the dev when they say 'contract is safu'",
  "watch your portfolio go -99.9% and call it a discount",
  "join a presale that never launches",
  "think you're early but you're actually exit liquidity",
  "buy because the chart 'looks bullish'",
  "trust a project because it has 'safe' in the name",
  "follow crypto influencers' financial advice",
  "forget to check if there's liquidity",
  "market buy without checking the market cap",
  "believe in the roadmap that ends in 'moon'",
  "swap your blue chips for a coin with 'Inu' in the name",
  "think you can time the top",
  "join a discord where everyone just posts 'wagmi'",
  "forget to sell after a 100x because you're sleeping",
  "buy the rumor, miss the news, catch the dump",
  "trust a project because they have an anime profile pic",
  "get excited about token burns that don't affect circulating supply",
  "believe the whitepaper written in comic sans",
  "join a project because they promise 'utility soon'",
  "think you're smarter than the bot frontrunning you",
  "approve a smart contract without reading it",
  "buy because the telegram group has lots of rocket emojis",
  "think your $100 investment will make you a millionaire",
  "follow trading advice from a hamster",
  "believe in the project because they have a 'doxxed team'",
  "wait for a dip in a ponzi",
  "think you've found a gem in your spam messages",
  "buy because the chart looks like a cup and handle",
  "trust a project that claims to be 'better than bitcoin'",
  "fall for the classic 'send 1 ETH, get 2 back' scam",
  "believe the dev who says 'we're in it for the tech'",
  "think liquidity is locked but it's actually a fork",
  "ape into a token because it has a cute logo",
  "join a project promising '100x guaranteed'",
  "believe the marketing roadmap full of CoinGecko listings",
  "trust a project because they have lots of Twitter followers",
  "think you're early but it's already been botted",
  "forget to take profits because 'moon soon'",
  "join a project because they promise 'NFT marketplace'",
  "believe in the 'partnership announcements coming soon'",
  "think you can beat the MEV bots",
  "ape after seeing 'financial advice' in a meme group",
  "trust a project because they have a Medium article",
  "believe the team when they say 'minor delay'",
  "join a presale because your favorite influencer tweeted about it",
  "think you've found a 'hidden gem' in a paid group",
  "forget to check if the contract is renounced",
  "buy because someone in telegram said 'next 1000x'",
  "trust a project because they have a 'professional website'",
  "believe in the 'revolutionary tokenomics'",
  "join a project because they promise 'metaverse integration'",
  "think you can outsmart the whale dumping",
  "ape into a fork of a fork of a fork",
  "believe the dev who says 'trust me bro'",
  "join a project because they have a 'strong community'",
  "think you're buying the bottom but it keeps dipping",
  "trust a project because they have a lot of locked liquidity",
  "believe in the 'organic growth' of bot transactions",
  "join a project because they promise 'staking soon'",
  "forget to check if the team tokens are locked",
  "buy because the chart formed a 'golden cross'",
  "trust a project because they have an 'audit'",
  "believe the 'partnership with big companies coming'",
  "join a project because they have a 'doxxed dev'",
  "think you can catch the bottom of a rugpull",
  "ape into a token because it has 'moon' in the name",
  "believe the dev who says 'we're here for the long term'",
  "join a project because they promise 'huge marketing'",
  "think you've found a gem in a paid call channel",
  "trust a project because they have a 'locked liquidity'",
  "believe in the 'revolutionary use case'",
  "join a project because they promise 'CEX listings soon'",
  "forget to check if the contract is verified",
  "buy because someone said 'NFA but...'",
  "trust a project because they have a 'strong team'",
  "believe in the 'organic community growth'",
  "join a project because they promise 'big partnerships'",
  "think you can time the market with TA on a memecoin",
  "ape into a token because it has a 'based dev'",
  "believe the 'we're going to change the world' pitch",
  "join a project because they have a 'great community'",
  "think you've found the next SHIB",
  "trust a project because they have a 'solid roadmap'",
  "believe in the 'fair launch' that's actually pre-mined",
  "join a project because they promise 'huge announcements'",
  "forget to check the token distribution",
  "buy because the chart looks like 'bullish'",
  "believe in the 'deflationary mechanics'",
  "join a project because they promise 'massive burns'",
  "think you can predict the next dog coin trend",
  "ape into a token because it has 'safe' in the name",
  "believe the 'we're building the future' narrative",
  "join a project because they have 'celebrity endorsements'",
  "think you've found a 'low mcap gem'",
  "trust a project because they have a 'locked team tokens'",
  "believe in the 'revolutionary technology'",
  "join a project because they promise 'passive income'",
  "forget to check the holder distribution",
  "buy because someone posted 'this is financial advice'"
];

const MemecoinGenerator = () => {
  const [phrase, setPhrase] = useState("when you _____");
  const [currentPhrase, setCurrentPhrase] = useState("");

  const generatePhrase = () => {
    const randomPhrase = phrases[Math.floor(Math.random() * phrases.length)];
    setPhrase("when you ");
    setCurrentPhrase(randomPhrase);
    
    let i = 0;
    const interval = setInterval(() => {
      setPhrase((prev) => prev + randomPhrase[i-1]);
      i++;
      if (i >= randomPhrase.length) clearInterval(interval);
    }, 50);
  };

  const handleTweet = () => {
    const tweetText = encodeURIComponent(`when you ${currentPhrase} $when`);
    window.open(`https://twitter.com/intent/tweet?text=${tweetText}`, '_blank');
  };

  return (
    
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-4 text-xl font-bold">
          
      <div className="mb-4">{phrase}</div>
      <div className="button-container">
        <button 
          className="generate-button"
          onClick={generatePhrase}
        >
          generate
        </button>
        <button 
          className="tweet-button"
          onClick={handleTweet}
        >
          tweet
        </button>

      </div>
      <br></br>
      <br></br>
      AiHX2zR756B6W6ckvyj6Xj2gYG1hbf7m5f34mCVepump
    </div>
  );
};

export default MemecoinGenerator;